// loaders
export const ACHIEVEMENTS_TABLE_LOADER = 'achievementsTableLoader'
export const TASKS_TABLE_LOADER = 'tasksTableLoader'
export const SHOP_TABLE_LOADER = 'shopTableLoader'
export const REDEMPTION_TABLE_LOADER = 'redemptionTableLoader'
